import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { AppProviders } from '@/app/providers';
import { createAppRouter } from '@/app/router';
import { createQueryClient } from '@/lib/query/client';

import '@/styles/globals.css';

const rootElement = document.getElementById('root');

if (rootElement === null) {
  throw new Error('Missing #root element in index.html');
}

/*
 * The cache is created before the router so both halves of the app share one
 * instance: the router carries it in `context` for loaders, and `AppProviders`
 * hands the same object to React.
 */
const queryClient = createQueryClient();
const router = createAppRouter(queryClient);

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders queryClient={queryClient}>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
